export const getLocalstorageKeyFromValue = (value: string): string | null => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      const storedValue = localStorage.getItem(key);
      if (storedValue === value) {
        return key;
      }
    }
  }

  return null;
};

export const isUserSubscribed = (username: string): boolean => {
  const userSubItems: { [key: string]: string } = {};

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('user_subscription-')) {
      const value = localStorage.getItem(key);
      if (value) {
        userSubItems[key] = value;
      }
    }
  }

  const isSubscriber = Object.values(userSubItems).some((url) => {
    const urlPart = url.replace(`${process.env.CLIENT_URL}/` || '', '');
    return urlPart === username;
  });

  return isSubscriber;
};
